var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_4042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.125C0 1.39893 1.41758 0 3.16667 0H11.0833V6.25C11.0833 7.11426 11.7909 7.8125 12.6667 7.8125H19V21.875C19 23.5986 17.5799 25 15.8333 25H3.16667C1.41758 25 0 23.5986 0 21.875V3.125ZM12.6667 6.25V0L19 6.25H12.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.219 17.098C4.479 17.098 5.207 16.335 5.207 15.467C5.207 14.732 4.822 14.298 4.178 14.039L3.527 13.78C3.065 13.598 2.743 13.486 2.743 13.192C2.743 12.919 2.974 12.765 3.359 12.765C3.765 12.765 4.087 12.905 4.43 13.164L5.053 12.38C4.598 11.925 3.961 11.694 3.359 11.694C2.253 11.694 1.469 12.394 1.469 13.269C1.469 14.025 1.98 14.48 2.526 14.697L3.191 14.977C3.639 15.166 3.926 15.264 3.926 15.565C3.926 15.845 3.709 16.02 3.247 16.02C2.834 16.02 2.351 15.803 1.987 15.488L1.273 16.349C1.812 16.846 2.54 17.098 3.219 17.098ZM6.0727 17H9.4537V15.95H7.3257V14.844H9.0687V13.794H7.3257V12.828H9.3767V11.785H6.0727V17ZM10.4819 17H13.7649V15.95H11.7349V11.785H10.4819V17ZM14.6655 17H17.9485V15.95H15.9185V11.785H14.6655V17Z",
    fill: "#495376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_4042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.3ac1b1400adcb495ea336fcd40e41e05.svg";
export { ForwardRef as ReactComponent };